import en from './en.json';
import es from './es.json';

export function get(language, identifier, defaultValue = '') {
  const defaultVal = typeof defaultValue === 'string' && defaultValue ? defaultValue : '';
  const id = typeof identifier === 'string' && identifier && identifier.length > 0
    ? identifier
    : '***NO_TRANSLATION_KEY_PROVIDED***';

  if (id === '***NO_TRANSLATION_KEY_PROVIDED***') {
    return defaultVal;
  }

  if (language === 'es') {
    return (typeof es === 'object' && es[id]) ? es[id] : defaultVal;
  }

  return (typeof en === 'object' && en[id]) ? en[id] : defaultVal;
}
